export function getFAQInnerScript() {
  return {
    __html: `</script>
      `,
  };
}
